import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Rasterize a bracket "stage" element and save it as a single-page PDF sized to
// the bracket (so the whole thing fits without cropping).
export async function exportBracketPdf(el, name) {
  if (!el) return;

  const canvas = await html2canvas(el, {
    backgroundColor: "#ffffff",
    scale: 2, // crisper text
    useCORS: true,
  });

  const imgData = canvas.toDataURL("image/png");
  const w = canvas.width;
  const h = canvas.height;

  const pdf = new jsPDF({
    orientation: w >= h ? "landscape" : "portrait",
    unit: "px",
    format: [w, h],
  });
  pdf.addImage(imgData, "PNG", 0, 0, w, h);

  const file =
    ((name || "bracket").trim().replace(/[^\w-]+/g, "_") || "bracket") + ".pdf";
  pdf.save(file);
}
